/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface OauthTokenRefreshRequest
 */
export interface OauthTokenRefreshRequest {
  /**
   * OAuth grant type
   * @type {string}
   * @memberof OauthTokenRefreshRequest
   */
  grant_type: OauthTokenRefreshRequestGrantTypeEnum
  /**
   * ID OAuth-клиента
   * @type {string}
   * @memberof OauthTokenRefreshRequest
   */
  client_id: string
  /**
   * Секрет OAuth-клиента
   * @type {string}
   * @memberof OauthTokenRefreshRequest
   */
  client_secret: string
  /**
   * RefreshToken
   * @type {string}
   * @memberof OauthTokenRefreshRequest
   */
  refresh_token: string
}

/**
 * @export
 * @enum {string}
 */
export enum OauthTokenRefreshRequestGrantTypeEnum {
  RefreshToken = 'refresh_token',
}

/**
 * Check if a given object implements the OauthTokenRefreshRequest interface.
 */
export function instanceOfOauthTokenRefreshRequest(
  value: object
): value is OauthTokenRefreshRequest {
  if (!('grant_type' in value) || value['grant_type'] === undefined)
    return false
  if (!('client_id' in value) || value['client_id'] === undefined) return false
  if (!('client_secret' in value) || value['client_secret'] === undefined)
    return false
  if (!('refresh_token' in value) || value['refresh_token'] === undefined)
    return false
  return true
}

export function OauthTokenRefreshRequestFromJSON(
  json: any
): OauthTokenRefreshRequest {
  return OauthTokenRefreshRequestFromJSONTyped(json, false)
}

export function OauthTokenRefreshRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OauthTokenRefreshRequest {
  if (json == null) {
    return json
  }
  return {
    grant_type: json['grant_type'],
    client_id: json['client_id'],
    client_secret: json['client_secret'],
    refresh_token: json['refresh_token'],
  }
}

export function OauthTokenRefreshRequestToJSON(
  value?: OauthTokenRefreshRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    grant_type: value['grant_type'],
    client_id: value['client_id'],
    client_secret: value['client_secret'],
    refresh_token: value['refresh_token'],
  }
}
